import baseForOwnRight from './_baseForOwnRight.js';
import createBaseEach from './_createBaseEach.js';

/**
 * The base implementation of `_.forEachRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEachRight = createBaseEach(baseForOwnRight, true);

export default baseEachRight;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_baseEachRight.js
// module id = 588
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38